import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import FolderIcon from '../../images/folder.svg';

const FolderRow = ({folder, goBack, goForward}) => {
  if (!goBack) {
    return (
      <a onClick={() => goForward(folder.id)} className='row'>
        <div className='folder-name'>
          <div className="icon-container">
            <img src={FolderIcon} alt="folder" />
          </div>
          <p>{folder.name}</p>
        </div>
      </a>
    );
  } else {
    return (
      <div onClick={goBack} className='row' style={{opacity: .6}}>
        <div className='folder-name'>
          <div className="icon-container">
            <img src={FolderIcon} alt="folder" />
          </div>
          <p style={{fontWeight: 'bold'}}>..</p>
        </div>
      </div>
    )
  }
};

export default FolderRow;
